// extracted by mini-css-extract-plugin
export default {"cell":"naCdG","contextMenu":"_TtVL","ellipsisCell":"FLA_c"};